// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-container {
  padding: 30px;
  background: #0b1220;
  min-height: 100vh;
  color: white;
}

/* HEADER SAME AS ARTICLE */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.add-btn {
  background: #facc15;
  color: #020617;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.add-btn:hover {
  background: #fde047;
}

/* TABLE SAME STYLE */
.employee-table {
  width: 100%;
  border-collapse: collapse;
  background: #0f172a;
  border-radius: 12px;
  overflow: hidden;
}

.employee-table th {
  background: #1e293b;
  padding: 14px;
  text-align: left;
}

.employee-table td {
  padding: 14px;
  border-top: 1px solid #1e293b;
}

.employee-table tr:hover {
  background: #1a2333;
}

/* ACTION ICONS SAME BOX STYLE */
.actions {
  display: flex;
  gap: 8px;
}

.actions svg {
  background: #1e293b;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  width: 28px;
  height: 28px;
}

.actions svg:hover {
  background: #334155;
}

.actions .delete:hover {
  background: #ef4444;
}

/* STATUS SAME PILL */
.status {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  text-transform: capitalize;
}

.status.Active {
  background: #d1fae5;
  color: #065f46;
}

.status.Inactive {
  background: #fee2e2;
  color: #991b1b;
}

/* ROLE PILL */
.role-pill {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  background: #1e293b;
}

/* PAGINATION MATCH */
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.pagination button {
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  background: #1e293b;
  color: white;
  cursor: pointer;
}

.pagination button:hover {
  background: #334155;
}

/* MODAL SAME AS ARTICLE */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 400px;
  color: #020617;
}

.filter-input {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #2c3e50;
  border-radius: 6px;
  font-size: 14px;
  background-color: #0f172a; /* dark background */
  color: #fff; /* white text */
}

/* Placeholder color */
.filter-input::placeholder {
  color: #94a3b8; /* light gray */
}

/* Focus effect */
.filter-input:focus {
  outline: none;
  border-color: #3b82f6; /* blue border */
  box-shadow: 0 0 0 1px #3b82f6;
}

/* NEW: row layout */
.filters-row {
  display: flex;
  gap: 12px;
  flex: 1 1;
  align-items: center;
}

/* same size inputs */
.filter-input,
.filter-select {
  flex: 1 1;
  min-width: 200px;
  margin-left: 10px;
  padding: 8px 12px;
  border: 1px solid #2c3e50;
  border-radius: 6px;
  font-size: 14px;
  background-color: #0f172a;
  color: #fff;
}

/* dropdown arrow fix */
.filter-select {
  cursor: pointer;
}

/* placeholder */
.filter-input::placeholder {
  color: #94a3b8;
}

/* focus */
.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* responsive */
@media (max-width: 768px) {
  .filters-row {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Employee Master/EmployeeList/EmployeeList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAE,oBAAoB;EAC/C,WAAW,EAAE,eAAe;AAC9B;;AAEA,sBAAsB;AACtB;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qBAAqB,EAAE,gBAAgB;EACvC,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;;EAEE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;;EAEE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".employee-container {\n  padding: 30px;\n  background: #0b1220;\n  min-height: 100vh;\n  color: white;\n}\n\n/* HEADER SAME AS ARTICLE */\n.header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.add-btn {\n  background: #facc15;\n  color: #020617;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.add-btn:hover {\n  background: #fde047;\n}\n\n/* TABLE SAME STYLE */\n.employee-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #0f172a;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.employee-table th {\n  background: #1e293b;\n  padding: 14px;\n  text-align: left;\n}\n\n.employee-table td {\n  padding: 14px;\n  border-top: 1px solid #1e293b;\n}\n\n.employee-table tr:hover {\n  background: #1a2333;\n}\n\n/* ACTION ICONS SAME BOX STYLE */\n.actions {\n  display: flex;\n  gap: 8px;\n}\n\n.actions svg {\n  background: #1e293b;\n  padding: 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: white;\n  width: 28px;\n  height: 28px;\n}\n\n.actions svg:hover {\n  background: #334155;\n}\n\n.actions .delete:hover {\n  background: #ef4444;\n}\n\n/* STATUS SAME PILL */\n.status {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.status.Active {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status.Inactive {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* ROLE PILL */\n.role-pill {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  background: #1e293b;\n}\n\n/* PAGINATION MATCH */\n.pagination {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n}\n\n.pagination button {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: none;\n  background: #1e293b;\n  color: white;\n  cursor: pointer;\n}\n\n.pagination button:hover {\n  background: #334155;\n}\n\n/* MODAL SAME AS ARTICLE */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 25px;\n  border-radius: 12px;\n  width: 400px;\n  color: #020617;\n}\n\n.filter-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #2c3e50;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: #0f172a; /* dark background */\n  color: #fff; /* white text */\n}\n\n/* Placeholder color */\n.filter-input::placeholder {\n  color: #94a3b8; /* light gray */\n}\n\n/* Focus effect */\n.filter-input:focus {\n  outline: none;\n  border-color: #3b82f6; /* blue border */\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n/* NEW: row layout */\n.filters-row {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n  align-items: center;\n}\n\n/* same size inputs */\n.filter-input,\n.filter-select {\n  flex: 1;\n  min-width: 200px;\n  margin-left: 10px;\n  padding: 8px 12px;\n  border: 1px solid #2c3e50;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: #0f172a;\n  color: #fff;\n}\n\n/* dropdown arrow fix */\n.filter-select {\n  cursor: pointer;\n}\n\n/* placeholder */\n.filter-input::placeholder {\n  color: #94a3b8;\n}\n\n/* focus */\n.filter-input:focus,\n.filter-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n/* responsive */\n@media (max-width: 768px) {\n  .filters-row {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
